import * as moment from 'moment';
import axios from 'axios';

import config from '../utils/config';
import * as PaymentsActions from '../actions/paymentsInfo';

import {
  authIdInputValue$,
  emailInputValue$,
} from '../selectors/findUser';
import { currentProductName$ } from '../selectors/product';
import {
  dateStart$,
  dateEnd$,
} from '../selectors/datepickers';

import ReduxAction from '../interfaces/ReduxAction';

const URL = config().payments;

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';

export const payments = (): ReduxAction => {
  return (dispatch, getState): void => {
    dispatch(PaymentsActions.fetchPaymentsPending());
    const params = new URLSearchParams();

    function paramsAppender (paramName, paramVal) {
      if (paramVal) {
        return params.append(paramName, paramVal);
      } else {
        return null;
      }
    }

    paramsAppender('customer_id', authIdInputValue$(getState()));
    paramsAppender('customer_email', emailInputValue$(getState()));
    paramsAppender('product', currentProductName$(getState()));
    paramsAppender('date_from', moment(dateStart$(getState())).format('YYYY-MM-DD'));
    paramsAppender('date_to', moment(dateEnd$(getState())).format('YYYY-MM-DD'));

    axios({
      method: 'post',
      url: URL,
      data: params,
    })
      .then(response => {
        dispatch(PaymentsActions.fetchPaymentsSuccess(response.data));
      })
      .catch(error => {
        // @ts-ignore
        dispatch(PaymentsActions.fetchPaymentsFail(error));
      });
  };
};
